var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalInstrument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 8.64584C16.3125 9.40834 16.6154 10.1396 17.1546 10.6788C17.6937 11.2179 18.425 11.5208 19.1875 11.5208C19.95 11.5208 20.6813 11.2179 21.2204 10.6788C21.7596 10.1396 22.0625 9.40834 22.0625 8.64584C22.0625 7.88335 21.7596 7.15208 21.2204 6.61291C20.6813 6.07374 19.95 5.77084 19.1875 5.77084C18.425 5.77084 17.6937 6.07374 17.1546 6.61291C16.6154 7.15208 16.3125 7.88335 16.3125 8.64584Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 1.9375C4.05 1.9375 3.31874 2.2404 2.77957 2.77957C2.2404 3.31874 1.9375 4.05 1.9375 4.8125V8.64583C1.9375 9.91666 2.44233 11.1354 3.34095 12.0341C4.23956 12.9327 5.45834 13.4375 6.72917 13.4375C8 13.4375 9.21878 12.9327 10.1174 12.0341C11.016 11.1354 11.5208 9.91666 11.5208 8.64583V4.8125C11.5208 4.05 11.2179 3.31874 10.6788 2.77957C10.1396 2.2404 9.40833 1.9375 8.64583 1.9375",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72916 13.4375V21.1042C6.72916 21.6125 6.93109 22.1 7.29054 22.4595C7.64998 22.8189 8.13749 23.0208 8.64582 23.0208C9.15415 23.0208 9.64167 22.8189 10.0011 22.4595C10.3606 22.1 10.5625 21.6125 10.5625 21.1042V15.5765C10.5625 14.9411 10.8149 14.3317 11.2642 13.8824C11.7135 13.4331 12.3229 13.1807 12.9583 13.1807C13.5937 13.1807 14.2031 13.4331 14.6524 13.8824C15.1017 14.3317 15.3542 14.9411 15.3542 15.5765V19.1875C15.3542 19.6958 15.5561 20.1834 15.9155 20.5428C16.275 20.9022 16.7625 21.1042 17.2708 21.1042C17.7792 21.1042 18.2667 20.9022 18.6261 20.5428C18.9856 20.1834 19.1875 19.6958 19.1875 19.1875V11.5208",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 0.979156V3.37499",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64584 0.979156V3.37499",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalInstrument);
export default __webpack_public_path__ + "static/media/medical-Instrument.9da417b4a603c048e97ea363587151f3.svg";
export { ForwardRef as ReactComponent };